import React from "react";
import { Link } from "react-router-dom";
import { Phone, CalendarDays, Sparkles } from "lucide-react";
import { CONTACT } from "@/data/site";

export const MobileActionBar = () => {
  return (
    <div data-testid="mobile-action-bar" className="lg:hidden fixed bottom-0 inset-x-0 z-40 glass border-t border-rossi-gold/20">
      <div className="grid grid-cols-3">
        <a href={CONTACT.phoneHref} data-testid="mab-call" className="flex flex-col items-center gap-1 py-3 text-rossi-cream/90 active:bg-white/5">
          <Phone size={18} className="text-rossi-gold" /><span className="text-[11px] font-medium">Call</span>
        </a>
        <Link to="/booking" data-testid="mab-book" className="flex flex-col items-center gap-1 py-3 text-rossi-cream/90 border-x border-white/10 active:bg-white/5">
          <CalendarDays size={18} className="text-rossi-gold" /><span className="text-[11px] font-medium">Book</span>
        </Link>
        <Link to="/studio" data-testid="mab-ai" className="flex flex-col items-center gap-1 py-3 text-rossi-cream/90 active:bg-white/5">
          <Sparkles size={18} className="text-rossi-gold" /><span className="text-[11px] font-medium">The Studio</span>
        </Link>
      </div>
    </div>
  );
};

export default MobileActionBar;
